export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isFunction.js
// module id = 252
// module chunks = 1